exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// /var/www/html/LASO/laso-client/node_modules/core-js/modules/_wks-ext.js
// module id = ../../../../core-js/modules/_wks-ext.js
// module chunks = polyfills